module.exports = __webpack_public_path__ + "static/img/logo-ma.dda6ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ma.png
// module id = Yq/0
// module chunks = 11